import { setAuth, setProfile } from "../reducers/authReducer";
import { setConfig } from "../reducers/configReducer";
import axios from "axios";
import getError from "../utils/getError";
import setAuthToken from "../utils/setAuthToken";
import url from "../utils/url";
import { isPermitted } from "../utils/PermissionManager";
import { masterFunction } from "../api/api";

export const loginAdmin = (data, loginAfterFunction) => (dispatch) => {
  axios
    .post(url + "/auth", data)
    .then((res) => {
      let resData = masterFunction(res, ".data");
      if (resData && resData.success) {
        const access_token =
          resData.access_token || resData.result?.access_token;
        let deviceInfo = null;
        if (window.deviceInfo) {
          deviceInfo = { ...window.deviceInfo };
        }
        setAuthToken(access_token, deviceInfo);
        dispatch(
          saveConfig((res) => {
            if (res) {
              localStorage.setItem("skyadmin", access_token);
              dispatch(setAuth(true));
            }
            loginAfterFunction(res);
          }),
        );
      } else {
        loginAfterFunction(false, resData?.message || "Invalid OTP");
      }
    })
    .catch((err) => {
      let error = getError(err);
      if (typeof error !== "string") {
        error = JSON.stringify(err);
      }
      loginAfterFunction(false, error);
    });
};

export const saveConfig = (afterAsync) => (dispatch) => {
  axios
    .get(url + "/config")
    .then((res) => {
      let config = masterFunction(res, ".result");
      if (config) {
        localStorage.setItem("config", JSON.stringify(config));
        let roles = config?.profile?.roles;
        let permitted = isPermitted(roles, ["admin", "crm", "customer_care"]);
        if (permitted) {
          afterAsync && afterAsync(true);
          dispatch(setConfig(config));
          dispatch(setProfile(config?.profile));
        } else {
          afterAsync && afterAsync(false);
          setAuthToken(null);
          localStorage.removeItem("skyadmin");
          localStorage.removeItem("config");
          dispatch(setConfig(null));
          dispatch(setProfile(null));
          window.location.href = "/unauthorized";
        }
      }
    })
    .catch((err) => {});
};
export const saveProfile = () => (dispatch) => {
  axios
    .get(url + "/profile")
    .then((res) => {
      let profile = masterFunction(res, ".result");
      if (profile) {
        let role = profile?.role ? profile?.role : "";
        dispatch(setProfile(profile));
      }
    })
    .catch((err) => {});
};

export const logoutAdmin = (afterFunction) => (dispatch) => {
  axios
    .delete(url + "/auth")
    .then((res) => {})
    .catch((err) => {});
  localStorage.removeItem("skyadmin");
  localStorage.removeItem("config");
  setAuthToken(null);
  dispatch(setAuth(false));
  dispatch(setProfile(null));
  dispatch(setConfig(null));
  afterFunction(true);
};

export const setAdmin = (isAuthenticated) => (dispatch) => {
  dispatch(setAuth(isAuthenticated));
};
export const setAdminProfile = (data) => {
  return {
    type: "SET_ADMIN_PROFILE",
    payload: data,
  };
};

export const setAdminRole = (data) => {
  return {
    type: "SET_ADMIN_ROLES",
    payload: data,
  };
};
